import { useState } from 'react'
import client from '../../utils/apollo-client'
import { Box, Flex, Heading, Center, Text } from '@chakra-ui/react'
import Link from 'next/link'
import { ProductContext } from '../../store'
import {
  FilterSidebar,
  Sidebar,
  Headerbar,
  BaseLayout,
  ProductGallery,
  HtmlHead,
} from '../../c'
import { GET_PRODUCTS_BY_PRINTER_SLUG } from '../../gql'
import { CheckoutButton } from '../../c/CheckoutButton'

export default function Home({ _products = [], printerName = '' }) {
  const [products, setProducts] = useState([..._products])
  return (
    <>
      <HtmlHead />
      <ProductContext.Provider value={[products, setProducts]}>
        <BaseLayout>
          <Headerbar />
          <Flex minW='100%' grow='1' direction={['column', 'column']}>
            <Center pt={4} bg='white' flexDir='column'>
              <Heading as='h2' size='md' textAlign='center' p={3}>
                Vørur til tin{' '}
                <span style={{ color: 'teal' }}>{printerName}</span>
              </Heading>

              <Text fontSize='sm'>
                <Link href='/'>Vel annan printara? Klikk her</Link>
              </Text>
            </Center>
            <Flex
              as='main'
              pl={{ md: 10, sm: 0 }}
              grow='1'
              bg='white'
              align='start'
              pos='relative'
              pb={12}
            >
              <ProductGallery initProducts={[..._products]} />
              <CheckoutButton />
            </Flex>
          </Flex>
        </BaseLayout>
      </ProductContext.Provider>
    </>
  )
}

export async function getServerSideProps({ query }) {
  const slug = query.slug
  console.log(slug)
  const { data } = await client.query({
    query: GET_PRODUCTS_BY_PRINTER_SLUG,
    variables: { slug },
  })

  return {
    props: {
      _products: data.printers[0]?.products.map((x) => x.product) || [],
      printerName: data.printers[0]?.name || '',
    },
  }
}
